import type { Plugin } from './plugin'

export class Selectors {
  /** Indicates if polling is started */
  public readonly isStarted

  constructor(plugin: Plugin, localStorage: Plugin['localStorage']) {
    this.isStarted = localStorage.selectors.isStarted
  }
}
